<div class="donut-graph">
  <div #chart class="circle-chart d-flex align-items-center justify-content-center" [style.width]="config.isVertical?'50%':'100%'"></div>
  <div #legend
    class="header d-flex align-items-center justify-content-around flex-wrap"
    [class.header-pull-right]="legendCanFitInRightSide"
    [class.flex-column]="config.isVertical"
    [style.width]="config.isVertical?'50%':'100%'"
    [style.paddingTop]="config.isVertical?'50px':'0'">
    <div *ngFor="let legend of legendItems" class="headerItem" (click)="selectByIndex(legend.index)" style="cursor: pointer;">
      <span class="headerCircle" [style.background]="legend.color"></span>
      <span style="display: table;">{{legend.name}}</span>
    </div>
  </div>
  <div class="footer-paragraph col-12"
       [style.width]="config.isVertical?'50%':'100%'"
       *ngIf="titleConfig?.footer" [innerHTML]="titleConfig.footer">
  </div>
</div>
